export const MAX_SITE_ID_LENGTH = 6;
export const SITE_ID_TOO_LONG_MESSAGE = "Site ID must be 6 characters or fewer.";

export function isSiteIdWithinLimit(id: string): boolean {
    return id.length <= MAX_SITE_ID_LENGTH;
}

export function siteIdCharacterCount(id: string): string {
    return `${id.length}/${MAX_SITE_ID_LENGTH}`;
}

export function isCloneSiteIdValid(cloneSiteId: string, sourceId: string): boolean {
    return /^[a-zA-Z0-9_-]+$/.test(cloneSiteId)
        && cloneSiteId.length > 0
        && cloneSiteId !== sourceId
        && isSiteIdWithinLimit(cloneSiteId);
}

export function cloneSiteIdHelperText(cloneSiteId: string, sourceId: string): string {
    if (!isSiteIdWithinLimit(cloneSiteId)) {
        return SITE_ID_TOO_LONG_MESSAGE;
    }
    return `${siteIdCharacterCount(cloneSiteId)} — Letters, numbers, underscores, and hyphens only. Must differ from the source site ID.`;
}
